import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';

// Interface for the request body, matching the C# backend model
export interface SaveBlogRequest {
  Title: string;
  Description: string;
  ImageName: string;
  SEO: string;
  Language: string;
}

// Interface for the API response
interface SaveBlogResponse {
  status: number;
  message: string;
}

export const saveBlog = async (blogData: SaveBlogRequest): Promise<SaveBlogResponse> => {
  // Client-side validation to prevent unnecessary API calls
  if (!blogData.Title || !blogData.Description || !blogData.ImageName || !blogData.SEO) {
    throw new Error("Todos los campos (título, descripción, nombre de imagen y SEO) son obligatorios.");
  }

  const token = localStorage.getItem('token');

  if (!token) {
    throw new Error('Token no disponible');
  }

  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/save-blog`;

    const response: AxiosResponse<SaveBlogResponse> = await axios.post(
      endpoint,
      blogData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error('Error al guardar el blog:', error);

    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message || 'No se pudo guardar el blog en el servidor.');
    }

    throw error; // Re-throw client-side validation errors or other known errors
  }
};

